import { useParams } from 'react-router-dom';
import React from 'react';
import { Link } from 'react-router-dom';
import { FiEdit3 } from 'react-icons/fi';
import useAuthorityLevel from '@/hooks/useAuthorityLevel';
import { t } from 'i18next';
import { TableCell, TableRow, TableUser, TableUserContent, TableUserTitle } from '@/components/ui/table';
import { CardIcon } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

export function CourseModuleAboutCardActivity({ activity, isNotFinished }) {
  const authorityLevel = useAuthorityLevel();
  const { courseId } = useParams();

  return (
    <TableRow>
      <TableCell>
        <TableUser>
          <CardIcon className="p-2">
            <FiEdit3 size={16} />
          </CardIcon>
          <TableUserContent>
            <TableUserTitle
              className="truncate text-base"
              title={activity?.title}
            >
              {activity?.title}
            </TableUserTitle>
          </TableUserContent>
        </TableUser>
      </TableCell>

      <TableCell>
        {activity?.status === 'Aguardando envio' || activity?.status === 'Activity not submitted' ? (
          <Badge
            size="xs"
            variant="warning"
          >
            {activity?.status}
          </Badge>
        ) : null}
        {activity?.status === 'Atividade não enviada' || activity?.status === 'Awaiting submission' ? (
          <Badge
            size="xs"
            variant="danger"
          >
            {activity?.status}
          </Badge>
        ) : null}
        {activity?.status === 'Atividade enviada' || activity?.status === 'Activity evaluated' ? (
          <Badge
            size="xs"
            variant="info"
          >
            {activity?.status}
          </Badge>
        ) : null}
        {activity?.status === 'Atividade avaliada' || activity?.status === 'Activity submitted' ? (
          <Badge
            size="xs"
            variant="info"
          >
            {activity?.status}
          </Badge>
        ) : null}
      </TableCell>

      <TableCell className="text-right">
        {!isNotFinished && (
          <Button
            variant="outline"
            size="sm"
            wide
            asChild
          >
            <Link to={authorityLevel === 'student' ? `/atividade-complementar/atividade/${activity?.id}` : `/atividade-complementar/${activity?.id}/${courseId}`}>{t('button.access')}</Link>
          </Button>
        )}
      </TableCell>
    </TableRow>
  );
}
